module.exports = __webpack_public_path__ + "static/media/24UHCHR24.57032bf7.jpg";